import { getServerApi } from '@/gql';
import { Permit } from '@/gql/graph/__generated__/request';
import user from '@/stores/user';
import { useState } from 'react';

export interface UseSetPersonalityPermitResult {
    permit: Permit | null;
    loading: boolean;
    error: Error | null;
    getSetPersonalityPermit: () => Promise<Permit | null>;
}

export const useSetPersonalityPermit = (
    tokenId: number,
): UseSetPersonalityPermitResult => {
    const [permit, setPermit] = useState<Permit | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    const { userId } = user;

    const getSetPersonalityPermit = async () => {
        if (!tokenId || !userId) {
            setPermit(null);
            return null;
        }
        try {
            setLoading(true);
            setError(null);
            const api = getServerApi();
            const response = await api.setPersonalityPermit({
                tokenId: tokenId,
            });
            if (response?.setPersonalityPermit !== undefined) {
                setPermit(response.setPersonalityPermit);
                return response.setPersonalityPermit;
            } else {
                setPermit(null);
                return null;
            }
        } catch (err) {
            console.error('Failed to fetch permit:', err);
            setError(
                err instanceof Error
                    ? err
                    : new Error('Failed to fetch permit'),
            );
            setPermit(null);
            return null;
        } finally {
            setLoading(false);
        }
    };

    return {
        permit,
        loading,
        error,
        getSetPersonalityPermit,
    };
};
